import React from 'react';
import { Divider } from '@mui/material';
import { useIsMobile } from '../../../hooks/useIsMobile';
import {
  AI_COLORS, AI_FONTS,
  TipBox, CheckItem,
  PageHero, ContentWrap, SectionTitle, Card,
  ImgSlot,
} from '../shared';

import img53 from '../../../imgs/adulto-idosos/53.png';

export default function SaudeSexual() {
  const isMobile = useIsMobile();

  return (
    <div style={{ fontFamily: AI_FONTS.body, background: 'transparent' }}>
      <PageHero
        title="Saúde Sexual"
        subtitle="A sexualidade faz parte da vida e do bem-estar das pessoas em todas as fases da vida, incluindo a fase adulta e o envelhecimento."
        audio="saude-sexual.m4a"
      />

      <ContentWrap>
        <p style={{ lineHeight: 1.75, marginTop: 0 }}>
          Cuidar da saúde sexual é importante para a qualidade de vida, para os relacionamentos e
          para a prevenção de doenças.
        </p>

        <SectionTitle>O que são Infecções Sexualmente Transmissíveis (IST)?</SectionTitle>
        <p style={{ lineHeight: 1.75 }}>
          As Infecções Sexualmente Transmissíveis, também conhecidas como IST, são doenças que podem
          ser transmitidas principalmente por meio de relações sexuais sem proteção. Alguns exemplos
          são:
        </p>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)',
            gap: 10,
            marginBottom: 16,
          }}
        >
          {['Sífilis', 'HIV/AIDS', 'Hepatite B', 'Gonorreia', 'Clamídia', 'Herpes genital'].map(
            (item, i) => (
              <Card key={i} variant={i} style={{ padding: '12px 16px', textAlign: 'center' }}>
                {item}
              </Card>
            )
          )}
        </div>

        <TipBox icon="ℹ️">
          Muitas dessas infecções podem não apresentar sintomas no início. Por isso, a prevenção e a
          realização de exames são importantes.
        </TipBox>

        <Divider style={{ margin: '32px 0', borderColor: AI_COLORS.bgBlue100 }} />

        <SectionTitle>Como se proteger?</SectionTitle>
        <p style={{ lineHeight: 1.75 }}>
          A principal forma de prevenção é o <strong>uso do preservativo em todas as relações
          sexuais</strong>. Além disso:
        </p>
        <ul style={{ padding: 0, margin: '0 0 8px' }}>
          <CheckItem>Realize exames de saúde regularmente</CheckItem>
          <CheckItem>Procure atendimento de saúde em caso de dúvidas ou sintomas</CheckItem>
          <CheckItem>Converse com seu parceiro ou parceira sobre prevenção</CheckItem>
          <CheckItem>Mantenha seu cartão de vacinação atualizado</CheckItem>
        </ul>

        <ImgSlot maxWidth={140} folder="adulto-idosos" filename={img53} alt="" caption="" />

        <Divider style={{ margin: '32px 0', borderColor: AI_COLORS.bgBlue100 }} />

        <SectionTitle>Quais sinais merecem atenção?</SectionTitle>
        <p style={{ lineHeight: 1.75 }}>Procure uma unidade de saúde se perceber:</p>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
            gap: 10,
            marginBottom: 16,
          }}
        >
          {[
            'Feridas na região íntima',
            'Corrimentos diferentes do habitual',
            'Coceira ou ardência',
            'Dor durante as relações sexuais',
            'Verrugas na região genital',
          ].map((item, i) => (
            <div
              key={i}
              style={{
                background: AI_COLORS.pink50,
                borderRadius: 8,
                padding: '10px 14px',
                borderLeft: '3px solid #EF9A9A',
                fontSize: '0.93rem',
              }}
            >
              ⚠️ {item}
            </div>
          ))}
        </div>

        <TipBox>
          Lembre-se: algumas IST podem não causar sintomas. Por isso, o acompanhamento com
          profissionais de saúde é importante.
        </TipBox>

        <Divider style={{ margin: '32px 0', borderColor: AI_COLORS.bgBlue100 }} />

        <SectionTitle>Saúde sexual na fase adulta e no envelhecimento</SectionTitle>
        <p style={{ lineHeight: 1.75 }}>
          Muitas pessoas acreditam que as IST afetam apenas os jovens, mas isso não é verdade.
          Adultos e idosos também podem adquirir infecções sexualmente transmissíveis quando não
          utilizam preservativo.
        </p>
        <p style={{ lineHeight: 1.75 }}>
          Independentemente da idade, cuidar da saúde sexual é uma forma de cuidar da sua saúde e do
          seu bem-estar. A sexualidade pode fazer parte da vida em qualquer idade. Informação,
          prevenção e cuidado são fundamentais para uma vida mais saudável.
        </p>

        <div
          style={{
            background: AI_COLORS.bgBlue50,
            borderLeft: `4px solid ${AI_COLORS.blue400}`,
            borderRadius: 10,
            padding: '18px 22px',
            marginTop: 20,
          }}
        >
          <p
            style={{
              fontFamily: AI_FONTS.title,
              color: AI_COLORS.blue900,
              fontSize: '1.05rem',
              margin: '0 0 8px',
            }}
          >
            Você sabia?
          </p>
          <p style={{ margin: 0, lineHeight: 1.75 }}>
            O uso do preservativo é importante em todas as idades. Muitas IST podem não apresentar
            sintomas, por isso a prevenção é a melhor forma de proteção.
          </p>
        </div>
      </ContentWrap>
    </div>
  );
}
